import React, { useContext } from "react";
import { Input } from "../../../../../controls";
import { InputAdornment } from "@mui/material";
import { AppContext } from "App";

const InputPrice = ({ item, handleInpChg }) => {
  const { settings } = useContext(AppContext);

  return (
    <Input
      fullWidth
      className="rmv-arrow"
      variant="outlined"
      placeholder="0.000"
      value={item.unitPrice}
      type="number"
      InputProps={{
        inputProps: {
          className: "!font-medium !text-gray-500",
        },
        startAdornment: (
          <InputAdornment position="start" className="!ml-[8px]">
            <span className="text-[16px] font-medium">
              {settings?.currSymbol || "$"}
            </span>
          </InputAdornment>
        ),
      }}
      onChange={(e) => {
        if (parseFloat(e.target.value) > 0)
          handleInpChg({
            key: item.key,
            name: "unitPrice",
            value: e.target.value,
          });
      }}
      size="small"
      sx={{
        maxWidth: "200px",
        "& .MuiInputBase-root": {
          padding: "0px 0px",
        },
        "& .MuiInputBase-input": {
          padding: "5px 0px",
          fontSize: "16px",
        },
      }}
    />
  );
};

export default InputPrice;
